<div class="welcome">
    <!-- Columna izquierda: Texto y botón -->
    <div class="welcome-text">
        <h1> Sube tu propiedad y muévela en menos de seis meses sin intermediarios. </h1>
        <app-page-navigation-bar
            [type]="'simple'"
            [nextPageURL]="'start'"
            [customTitle]="'Comenzar'"
        ></app-page-navigation-bar>
    </div>

    <!-- Columna derecha: Imágenes apiladas -->
    <div class="welcome-images">
        <img class="image image-1" src="assets/layout/images/home/1.png" alt="Card 1" />
        <img class="image image-2" src="assets/layout/images/home/2.png" alt="Card 2" />
        <img class="image image-3" src="assets/layout/images/home/3.png" alt="Card 3" />
    </div>
</div>
